import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=47b517ac&scoped=true&"
import script from "./logins.vue?vue&type=script&lang=js&"
export * from "./logins.vue?vue&type=script&lang=js&"
import style0 from "./logins.vue?vue&type=style&index=0&id=47b517ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b517ac",
  null
  
)

export default component.exports